"use client";

import { BannerRep } from "@/api/home";
import Box from "@/components/Box";
import Empty from "@/components/Empty";
import Loading from "@/components/Loading";
import { server } from "@/utils/client";
import clsx from "clsx";
import Image from "next/image";
import React from "react";
import styles from "./style.module.scss"; // Import the CSS modul

const getPromotionApi = async (category_id?: number) => {
    return server
        .request<BannerRep[]>({
            url: "/v1/api/front/activity_promotion",
            method: "post",
            data: { category_id },
        })
        .then((res) => {
            if (res.code === 200) return res.data;
            return [];
        });
};

const getPromotionCategoryApi = async () => {
    return server
        .request<any>({
            url: "/v1/api/front/activity_promotion_category",
            method: "post",
        })
        .then((res) => {
            if (res.code === 200) return res.data;
            return [];
        });
};

const registePromoClick = (activity_id: number) => {
    return server
        .request({
            url: "/v1/api/front/activity_promotion_click",
            method: "post",
            data: { activity_id },
        })
        .then((res) => {
            if (res.code === 200) return res.data;
            return [];
        });
};

const Promo = () => {
    const [category, setCategory] = React.useState<any>([]);
    const [promotion, setPromotion] = React.useState<BannerRep[]>([]);
    const [act, setAct] = React.useState(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    React.useEffect(() => {
        getCategoryList();
    }, []);

    React.useEffect(() => {
        if (act === 0) {
            getPromotionList();
        } else {
            getPromotionList(act);
        }
    }, [act]);

    const getCategoryList = async () => {
        const category = await getPromotionCategoryApi();
        setCategory(category || []);
    };
    const getPromotionList = async (id?: number) => {
        try {
            setIsLoading(true);
            const promotion = await getPromotionApi(id);
            setPromotion(promotion || []);
        } finally {
            setIsLoading(false);
        }
    };

    const doChange = (id: number) => {
        setAct(id);
    };

    const registePromo = (id?: number) => {
        if (!id) return;
        registePromoClick(id);
    };

    if (!category.length && !isLoading) {
        return <Empty />;
    }

    return (
        <div className="flex h-[100%] items-stretch">
            <div className="hidden w-[0px] w-[1.2rem] overflow-auto pr-[0px]">
                {category.map((item: any) => {
                    return (
                        <div
                            key={item.id}
                            className={clsx(styles.categoryItem, {
                                [styles.active]: act === item.id,
                                [styles.small]: item.id,
                            })}
                            onClick={() => doChange(item.id)}
                        >
                            {item.id != 0 && item.name}
                            {item.id === 0 && (
                                <>
                                    <Image
                                        alt="category"
                                        src="/promo/category.png"
                                        width={16}
                                        height={16}
                                    ></Image>
                                    <div className="ml-[.04rem]">Abrangente</div>
                                </>
                            )}

                            {!!item.badge_count && (
                                <div className={styles.categoryItemNum}>
                                    {item.badge_count > 99 ? `99+` : item.badge_count}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            <div className="flex-1 overflow-auto">
                {!isLoading &&
                    promotion.map((item, index) => (
                        <Box
                            key={item.id}
                            action={item.action_type}
                            actionData={item.action_params}
                            className={styles.promoItem}
                            onBeforeHandler={() => registePromo(item.id)}
                        >
                            <img
                                width={0}
                                height={0}
                                src={item.content!}
                                alt={"Image"}
                                className={"h-[1.16rem] w-[100%] rounded-[0.0833rem]"}
                            />
                            {item.is_badge && <div className={styles.promoItemNum}></div>}
                        </Box>
                    ))}
                {isLoading && (
                    <div className="flex h-[100%] items-center justify-center">
                        <Loading></Loading>
                    </div>
                )}
                {!promotion.length && <Empty />}
            </div>
        </div>
    );
};

export default Promo;
